module.exports = __webpack_public_path__ + "img/about_us_main.a3b60ccd.png";